var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2001C0 2.37793 0.326606 1.58943 0.907969 1.00807C1.48933 0.426704 2.27783 0.100098 3.1 0.100098H27.9C28.7222 0.100098 29.5107 0.426704 30.092 1.00807C30.6734 1.58943 31 2.37793 31 3.2001V21.8001C31 22.6223 30.6734 23.4108 30.092 23.9921C29.5107 24.5735 28.7222 24.9001 27.9 24.9001H3.1C2.27783 24.9001 1.48933 24.5735 0.907969 23.9921C0.326606 23.4108 0 22.6223 0 21.8001V3.2001ZM5.45445 3.2001L15.5 11.9901L25.5456 3.2001H5.45445ZM27.9 5.26005L16.5215 15.2172C16.2388 15.4649 15.8758 15.6014 15.5 15.6014C15.1242 15.6014 14.7612 15.4649 14.4785 15.2172L3.1 5.26005V21.8001H27.9V5.26005Z",
    fill: "#0984FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.15e65b35fad40411cb5979ea7a878562.svg";
export { ForwardRef as ReactComponent };